import React from 'react';
import { TFunction } from 'i18next';
import { DataTableMeta, LimitedContent } from '@otp/ui';
import { Permission, Tag } from 'src/graphql/generated/graphql';
import { ActionsColumn, ActionType } from './columns/actions';
import { TagsField } from 'src/components/common/table/columns/tags';

export const getTableConfig = (
  permissions: Partial<Permission>[],
  {
    t,
    onChange,
    action,
  }: { t: TFunction; onChange: (id: string) => void; action: ActionType },
) => [
  {
    name: 'name',
    label: t('common.name'),
  },
  {
    name: 'description',
    label: t('common.description'),
    options: {
      customBodyRender: (value: string) => {
        return (
          <LimitedContent maxRows={2}>
            <div dangerouslySetInnerHTML={{ __html: value }} />
          </LimitedContent>
        );
      },
    },
  },
  {
    name: 'tags',
    label: t('common.tags'),
    options: {
      customBodyRender: (tags: Tag[]) => {
        return <TagsField tags={tags} />;
      },
    },
  },
  {
    name: 'actions',
    label: t('common.actions'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const permission = permissions[column.rowIndex];

        return (
          <ActionsColumn
            onChange={() => onChange(permission.id)}
            action={action}
          />
        );
      },
    },
  },
];
